export default "__VITE_ASSET__LykIXeoN__"